import { gql } from '@apollo/client';

const requiredCommonFieldsWur2 = `
  numberOfAcademicStaff
  numberOfAcademicStaffOfInternationalOrOverseasOrigin
  numberOfResearchStaff
  totalNumberOfStudents
  totalNumberOfStudentsOfInternationalOrOverseasOrigin
  numberOfUndergraduateDegreesAwarded
  numberOfDoctoratesAwarded
  numberOfResearchDoctoratesAwarded
  numberOfProfessionalDoctoratesAwarded
  totalInstitutionalIncome
  researchIncome
  researchIncomeFromIndustryAndCommerce
  totalPublications
  internationalPublications
  researchVotes
  teachingVotes
  citationScoreCnNormalised
  citationScoreNormalised
`;

const requiredCommonFieldsWur3 = `
  ${requiredCommonFieldsWur2}
  totalNumberOfOutboundExchangeStudents
  percentileFieldWeightedCitationImpact
  numberOfPublicationsInTheTop10Percentile
  influenceOfPublications
  numberOfPatentsCitingResearch
`;
export const getSubmissionQueryWur2 = gql`
  query SubmissionWur2($institutionId: String!, $year: Int!) {
    institution(institutionId: $institutionId) {
       currency
    }
    submission(institutionId: $institutionId, year: $year) {
      institutionId
      year
      overall {
        applicable
        ${requiredCommonFieldsWur2}
      }
      artsAndHumanities {
        applicable
        ${requiredCommonFieldsWur2}
      }
      businessAndEconomics {
        applicable
        ${requiredCommonFieldsWur2}
      }
      clinicalAndHealth {
        applicable
        ${requiredCommonFieldsWur2}
      }
      computerScience {
        applicable
        ${requiredCommonFieldsWur2}
      }
      education {
        applicable
        ${requiredCommonFieldsWur2}
      }
      engineering {
        applicable
        ${requiredCommonFieldsWur2}
      }
      law {
        applicable
        ${requiredCommonFieldsWur2}
      }
      lifeSciences {
        applicable
        ${requiredCommonFieldsWur2}
      }
      physicalSciences {
        applicable
        ${requiredCommonFieldsWur2}
      }
      psychology {
        applicable
        ${requiredCommonFieldsWur2}
      }
      socialSciences {
        applicable
        ${requiredCommonFieldsWur2}
      }
    }
  }
`;

export const getSubmissionQueryWur3 = gql`
  query SubmissionWur3($institutionId: String!, $year: Int!) {
    institution(institutionId: $institutionId) {
       currency
    }
    submission(institutionId: $institutionId, year: $year) {
      institutionId
      year
      overall {
        applicable
        ${requiredCommonFieldsWur3}
      }
      artsAndHumanities {
        applicable
        ${requiredCommonFieldsWur3}
      }
      businessAndEconomics {
        applicable
        ${requiredCommonFieldsWur3}
      }
      clinicalAndHealth {
        applicable
        ${requiredCommonFieldsWur3}
      }
      computerScience {
        applicable
        ${requiredCommonFieldsWur3}
      }
      education {
        applicable
        ${requiredCommonFieldsWur3}
      }
      engineering {
        applicable
        ${requiredCommonFieldsWur3}
      }
      law {
        applicable
        ${requiredCommonFieldsWur3}
      }
      lifeSciences {
        applicable
        ${requiredCommonFieldsWur3}
      }
      physicalSciences {
        applicable
        ${requiredCommonFieldsWur3}
      }
      psychology {
        applicable
        ${requiredCommonFieldsWur3}
      }
      socialSciences {
        applicable
        ${requiredCommonFieldsWur3}
      }
    }
  }
`;

export const submissionQueryVariables = (
  institutionId: string,
  year: number,
) => ({
  variables: {
    institutionId,
    year,
  },
});
